export default "__VITE_ASSET__CCsjObD5__"